module.exports = __webpack_public_path__ + "img/yyys-fuzb2.feb6082c.webp";